/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'
import { LinearProgress } from '@mui/material'

export const Spinner = (): JSX.Element => {
	return (
		<View css={style}>
			<View className="innerDiv">
				<View className="loadingView">
					<Text>Loading...</Text>
					<LinearProgress className="loadingProgress" />
				</View>
			</View>
		</View>
	)
}

const style = css({
	width: '100%',
	height: '100vh',
	overflow: 'hidden',

	'.innerDiv': {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		maxWidth: '30rem',
		height: '100%',
		margin: 'auto',
	},
	'.loadingView': {
		position: 'relative',
		width: '20rem',
		height: '21rem',
		margin: 'auto',
		padding: '2rem',
	},
	'.loadingProgress': {
		margin: 'auto',
	},
})
